// extracted by mini-css-extract-plugin
module.exports = {"footer":"CampaignFooter_footer__MCMDs","socialLinks":"CampaignFooter_socialLinks__ANy5F","socialLinkLogo":"CampaignFooter_socialLinkLogo__zORnT"};